// BockData > IBlockData
import { BlockGroupState } from '../BlockGroup'
import { IBlockType } from '../BlockType'

export enum BlockDataStatus {
	POST = 'post',
	PUT = 'put',
	DELETE = 'delete'
}

export interface IBlockData<BlockTypesType> {
	indexes: number[]
	types: IBlockType<BlockTypesType>[]
	label: string
	id: number
	color: string[]
	cssColor: string
	status?: BlockDataStatus
	addBlockType(blockType: IBlockType<BlockTypesType>): IBlockType<BlockTypesType>[]
	removeBlockType(blockType: IBlockType<BlockTypesType>): IBlockType<BlockTypesType>[]
}

export type BlockDataOptionalProps = Partial<{
	initBlockGroupState: Partial<BlockGroupState>
	id: number
	status: BlockDataStatus
}>
